module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/quotas/quota-new-form/quota-new-form.component.sass
// module id = ./src/app/quotas/quota-new-form/quota-new-form.component.sass
// module chunks = main